export default __webpack_public_path__ + "static/10-60898c31716d70dd05c6f7e5932d3866.jpg";